import React, { useEffect, useState } from "react";
import { Card, CardContent, CardHeader, Grid, Typography } from "@mui/material";
import { VpnKeyTwoTone } from "@mui/icons-material";
import { useAuth } from "../../../providers/AuthProvider";
import axios from "axios";
import ChangePasswordDialog from "../../../components/ChangePassword/Dialog";
import ChangePicture from "../ChangePicture";
import MemberService from "../../../services/MemberService";

import "./Profile.css";

function ProfileForm() {
    const { user } = useAuth();
    const [ memberId, setMemberId ] = useState([]);
    const [ memberBenefitsAccess, setMemberBenefitsAccess ] = useState([]);
    const [ membershipBenefitsDepartmentPhone, setMembershipBenefitsDepartmentPhone ] = useState([]);

    useEffect(() => {
        let active = true;
        const source = axios.CancelToken.source();
        MemberService.getMemberId(user.id, source.token)
            .then((memberId) => {
                if (active) {
                    setMemberId(memberId);
                }
            })
            .catch(error => {
                if (!axios.isCancel(error)) {
                    console.log("Couldn't load member ID for User #" + user.id);
                }
            });

        return function cleanup() {
            active = false;
            // Cancels requests (cleanup) on component unmount
            source.cancel()
        }
    }, [user]);

    useEffect(() => {
        let active = true;
        const source = axios.CancelToken.source();
        MemberService.getMemberBenefitsAccess(source.token)
            .then((memberBenefitsAccess) => {
                if (active) {
                    setMemberBenefitsAccess(memberBenefitsAccess);
                }
            })
            .catch(error => {
                if (!axios.isCancel(error)) {
                    console.log("Couldn't load member benefits access.");
                }
            });

        return function cleanup() {
            active = false;
            // Cancels requests (cleanup) on component unmount
            source.cancel()
        }
    }, []);

    useEffect(() => {
        let active = true;
        const source = axios.CancelToken.source();
        MemberService.getMembershipBenefitsDepartmentPhone(source.token)
            .then((membershipBenefitsDepartmentPhone) => {
                if (active) {
                    setMembershipBenefitsDepartmentPhone(membershipBenefitsDepartmentPhone);
                }
            })
            .catch(error => {
                if (!axios.isCancel(error)) {
                    console.log("Couldn't load membership benefits department phone.");
                }
            });

        return function cleanup() {
            active = false;
            // Cancels requests (cleanup) on component unmount
            source.cancel()
        }
    }, []);

    return (
        <Card>
            <CardHeader title="Profile" />
            <CardContent>
                <Grid container spacing={2}>
                    <Grid item xs={12} className="profile">
                        <ChangePicture/>
                        <div className="profile-name">
                            <Typography variant="h5">
                                {`${user.firstName} ${user.lastName}`}
                            </Typography>
                            {user.address && (
                                <Typography variant="body1" color="textSecondary">
                                    {`${user.address.city}, ${user.address.state}`}
                                </Typography>
                            )}
                            <Typography variant="h6" color="textSecondary">
                                Member ID: {memberId}
                            </Typography>
                            {memberBenefitsAccess.toString() !== "" ?
                                // Data is stripped of HTML tags in the API
                                <Typography variant="subtitle2" color="textSecondary"
                                    dangerouslySetInnerHTML={{__html: `Access your member benefits: <a target="_blank" href=${memberBenefitsAccess.toString()}>${memberBenefitsAccess.toString()}</a>`}}
                                >
                                </Typography>
                                : null
                            }
                            {membershipBenefitsDepartmentPhone.toString() !== "" ?
                                // Data is stripped of HTML tags in the API
                                <Typography variant="subtitle2" color="textSecondary">
                                    To reach the membership benefits department call: {membershipBenefitsDepartmentPhone.toString()}
                                </Typography>
                                : null
                            }
                            <ChangePasswordDialog 
                                variant="outlined" 
                                color="primary" 
                                size="small"
                                startIcon={<VpnKeyTwoTone />} />
                        </div>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
}

export default ProfileForm;